import theme from '@styles/theme';
const alignSelfArray = {
  left: 'flex-start',
  right: 'flex-end',
  center: 'center'
};
export default {
  section: (marginTop = '116', marginBottom = '116', background = '') => ({
    display: 'flex',
    justifyContent: 'center',
    pt: [`${marginTop}px`],
    pb: [`${marginBottom}px`],
    pl: ['20px'],
    pr: ['20px'],
    backgroundColor: background || 'transparent',
    position: 'relative',
    zIndex: theme.zIndex.documentUp
  }),
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyItems: 'flex-start',
    alignItems: 'flex-start',
    width: '100%',
    'ol li, ul li, li p': {
      mb: theme.mbSection
    },
    'ol, ul': {
      listStylePosition: 'outside',
      ml: 16
    },
    'ol ol, ul ul': {
      ml: 16,
      mt: 16
    },
    maxWidth: ['100%', '100%', '478px', '903px'],
    'h2, h3, h4, h5': {
      mb: ['24px', '24px', '24px', '40px'],
      '&:last-child': {
        mb: 0
      }
    },
    'p, ul': {
      mb: ['6px', '6px', '12px', '12px'],
      '&:last-child': {
        mb: 0
      }
    }
  },
  contentContainer: (lineSpacing: number) => ({
    width: '100%',
    lineHeight: `${lineSpacing}%`,
    'h2, h3, h4, h5': {
      mb: `${lineSpacing}px`
    },
    'p, ul': {
      mb: `${lineSpacing}px`,
      a: {
        textDecoration: 'underline'
      }
    }
  }),
  buttonContainer: (align: 'left' | 'right' | 'center') => ({
    mt: ['24px', '24px', '24px', '40px'],
    alignSelf: alignSelfArray[align] || 'flex-start',
    'h2, h3, h4, p': {
      textAlign: align
    },
    ...(align === 'center' && {
      'button, a': {
        display: 'block',
        margin: '0 auto'
      }
    })
  }),
  buttonsContainer: (align: 'left' | 'right' | 'center') => ({
    mt: ['24px', '24px', '24px', '40px'],
    alignSelf: alignSelfArray[align] || 'flex-start',
    'h2, h3, h4, p': {
      textAlign: align
    },
    display: 'flex',
    flexFlow: ['column', 'column', 'row'],
    ...(align === 'center' && {
      'button, a': {
        display: 'block',
        margin: '0 auto'
      }
    })
  }),
  additionalText: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    m: ['16px 0', '16px 0', '0 16px', '0 16px', '0 24px'],
    span: {
      color: theme.rawColors.neutralBlack,
      fontSize: theme.fontSizes.h4
    }
  }
};